import productMarkEnum from './productMark'
import activityStatusEnum from './activityStatus'
import orderStatusEnum from './orderStatus'
import paymentStatusEnum from './payStatus'
import shippingStatusEnum from './shippingStatus'
import shippingTypeEnum from './shippingType'
import paymentsEnum from './payments'
import refundEnum from './refundStatus'
import Enum from './enum'
const productMark = new Enum(productMarkEnum);
const activityStatus = new Enum(activityStatusEnum);
const orderStatus = new Enum(orderStatusEnum);
const payStatus = new Enum(paymentStatusEnum);
const shippingStatus = new Enum(shippingStatusEnum);
const shippingType = new Enum(shippingTypeEnum);
const payments = new Enum(paymentsEnum);
const refundStatus = new Enum(refundEnum);

export default {
  productMark,
  activityStatus,
  orderStatus,
  payStatus,
  shippingStatus,
  shippingType,
  payments,
  refundStatus
}
